var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react"; // @ts-ignore
import { setCampaignData, setPaymentModeData } from "../../services/functions";
import { findParamInLocalStorage } from "../../utils/getAnyDataLocalStorge";
import { updateStepByPath } from "ah_utility/workflow";
import PagesHeader from "ah_utility/PagesHeader";
import { useDispatch } from "react-redux";
import { GetCatalogPlanReference } from "../../fnx/catalog/getCatalogPlanReference";
import { showErrorToast } from "../../fnx/showError";
import { icons, sizesIcon, typeAlert, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { themeCore } from "../../assets/themes/theme";
import LocalStorageService from "../../services/localStorage";
import { PlanView } from "./ui/view";
import { useLocation, useNavigate } from "react-router-dom";
import { useStepNavigation } from "ah_utility/NavigationEngine";
import { navigateBack } from "../../dataBase/stepProgress";
import { Steps } from "../../enum/steps";
import { useTranslation } from "react-i18next";
import { STEP_PLAN } from "../../const/catalog";
import useSelectors from "./components/selectors";
import useUI from "./components/ui";
import usePlan from "./components/plan";
import { PlansHeader } from "./ui/header";
import { useGetSteps } from "../../utils/getSteps";
import { useGetSummary } from "../../utils/getSummary";
import { plansClearData } from "../../store/plans/actions";
import { travelPremiums, travelPremiumsClearData, } from "../../store/travelPremiums/actions";
import { useCompleteStep } from "../../utils/responseComplete";
import { useErrorHandling } from "./hooks/useErrorHandling";
import { usePriceTable } from "./hooks/usePriceTable";
import { getQuoteList } from "../../utils/normalizeQuoteResponse";
var STEP = STEP_PLAN;
var storageKey2 = "assurehub";
var lsLogin = new LocalStorageService(storageKey2);
var storageKeyVariables = "afy-variables";
var lsVariables = new LocalStorageService(storageKeyVariables);
var Plan = function () {
    var dispatch = useDispatch();
    var t = useTranslation().t;
    var buildPriceTableFromDataPrimes = usePriceTable().buildPriceTableFromDataPrimes;
    var storageKey = "afy-steps";
    var steps = useGetSteps();
    var localStorageService = new LocalStorageService(storageKey);
    var storageKeyActionFlags = "afy-action-flags";
    // const storageKeyActionFlags = "afy-steps";
    var lsActionFlags = new LocalStorageService(storageKeyActionFlags);
    var navigate = useNavigate();
    var pathname = useLocation().pathname;
    var isLastPage = useStepNavigation({ currentStepId: pathname }).isLastPage;
    var clientId = React.useState(findParamInLocalStorage("clientId"))[0];
    /*Adiciona flag para validar, si se muestran los rangos de edad
     * en el detalle de los planes*/
    var flags = React.useState(lsActionFlags.getPageActionFlagsStored())[0];
    var _a = React.useState(false), enableAgeRange = _a[0], setEnabledAgeRange = _a[1];
    var _b = React.useState(false), enableShowExtra = _b[0], setEnableShowExtra = _b[1];
    var _c = React.useState([]), filtersQuotes = _c[0], setFiltersQuotes = _c[1];
    var _d = React.useState([]), rowsQuotes = _d[0], setRowsQuotes = _d[1];
    var _e = React.useState(""), selectedPlanId = _e[0], setSelectedPlanId = _e[1];
    var _f = React.useState(false), updating = _f[0], setUpdating = _f[1];
    var _g = React.useState(""), changedPlanId = _g[0], setChangedPlanId = _g[1];
    var _h = React.useState(false), error = _h[0], setError = _h[1];
    var _j = React.useState(""), helperText = _j[0], setHelperText = _j[1];
    var _k = useState(1), planPage = _k[0], setPlanPage = _k[1];
    var _l = useState(20), planLimit = _l[0], setPlanLimit = _l[1];
    var _m = useState(0), countPagination = _m[0], setCountPagination = _m[1];
    var _o = useState(false), showDropdown0 = _o[0], setShowDropdown0 = _o[1];
    var _p = useState(false), showPersonType = _p[0], setShowPersonType = _p[1];
    var _q = useState(false), showFeeType = _q[0], setShowFeeType = _q[1];
    var _r = useState(""), label0 = _r[0], setLabel0 = _r[1];
    var _s = useState(""), planCatalogType = _s[0], setPlanCatalogType = _s[1];
    var _t = useState(""), priceTableHeaderPrice = _t[0], setPriceTableHeaderPrice = _t[1];
    var _u = useState(""), summaryDisclaimer = _u[0], setSummaryDisclaimer = _u[1];
    var _v = React.useState(true), enable = _v[0], setEnable = _v[1];
    /*Polizas o cotizaciones*/
    var _w = React.useState(false), showModalQuotes = _w[0], setShowModalQuotes = _w[1];
    var onCloseModalQuotes = function () {
        setShowModalQuotes(false);
    };
    var _x = React.useState([]), extraInfoNames = _x[0], setExtraInfoNames = _x[1];
    var _y = React.useState([]), extraInfoNamesAut = _y[0], setExtraInfoNamesAut = _y[1];
    var _z = React.useState(1), page = _z[0], setPage = _z[1];
    var _0 = React.useState(100), limit = _0[0], setLimit = _0[1];
    var _1 = React.useState(false), isDetailClick = _1[0], setIsDetailClick = _1[1];
    var _2 = React.useState(false), isSingleCompareClick = _2[0], setIsSingleCompareClick = _2[1];
    var _3 = React.useState({ id: "", name: "", value: "" }), paymentModelSelected = _3[0], setPaymentModelSelected = _3[1];
    var _4 = React.useState(), coverTypeSelected = _4[0], setCoverTypeSelected = _4[1];
    var _5 = React.useState({
        id: "",
    }), planSelected = _5[0], setPlanSelected = _5[1];
    var _6 = React.useState({
        id: "",
    }), planSelectedNextStep = _6[0], setPlanSelectedNextStep = _6[1];
    var _7 = React.useState([]), planSelectedCompare = _7[0], setPlanSelectedCompare = _7[1];
    var _8 = React.useState(false), showDetail = _8[0], setShowDetail = _8[1];
    var _9 = React.useState(false), showCompareDetail = _9[0], setShowCompareDetail = _9[1];
    var projectId = React.useState(findParamInLocalStorage("projectId"))[0];
    var summary = useGetSummary();
    var _10 = useState([]), filters = _10[0], setFilters = _10[1];
    var _11 = React.useState(""), namePlan = _11[0], setNamePlan = _11[1];
    var _12 = React.useState([]), paymentMode = _12[0], setPaymentMode = _12[1];
    var _13 = React.useState(true), isInitialLoad = _13[0], setIsInitialLoad = _13[1];
    var _14 = React.useState(null), dropDown0Options = _14[0], setDropDown0Options = _14[1];
    var _15 = React.useState(""), selectedDropDown0 = _15[0], setSelectedDropDown0 = _15[1];
    var _16 = React.useState(true), triggerCatalog = _16[0], setTriggerCatalog = _16[1];
    var _17 = React.useState([]), allPlans = _17[0], setAllPlans = _17[1];
    var campaignInfo = React.useState(findParamInLocalStorage("campaign"))[0];
    var insuranceType = React.useState(localStorageService.getStepStored().steps[Steps.insurance].name)[0];
    var insurance = React.useState(localStorageService.getStepStored().steps[Steps.insurance].name)[0];
    var _18 = React.useState(false), showDetails = _18[0], setShowDetails = _18[1];
    var _19 = React.useState([]), stepsData = _19[0], setStepsData = _19[1];
    var _20 = React.useState([]), breadCrumbs = _20[0], setBreadCrumbs = _20[1];
    var _21 = React.useState({
        titlePage: "Plan",
        viewType: "2",
        titleMetaTag: "Affinity Plan",
        informationPage: {
            backgroundColor: themeCore.colors.background,
            colorText: themeCore.colors.secondaryText,
            description: "Seleccion el plan que necesite el cliente",
            icon: icons.Help,
            iconSize: sizesIcon.standard,
            iconColor: themeCore.colors.primary,
        },
        filter: {
            backgroundColor: "#FFFFFF",
            bgChipInsurers: "#fff",
            bgChipInsurersSelected: "#EBEEF6",
            bgColorButton: "#fff",
            bgColorComparativeButton: "#3A56A1",
            bgColorIconButton: "#EBEEF6",
            bgColorIconButtonSelected: "#3A56A1",
            colorIconButton: "#3A56A1",
            colorIconButtonSelected: "#fff",
            colorIconChip: "#3A56A1",
            colorText: "#3A56A1",
            comparativeTextButton: "ver comparativa",
            comparativeTextColor: "#fff",
            insurers: [],
            title: "Patrocinador",
            titleFirstChip: "Todas",
            comparativeButtonDisabled: false,
        },
        data: [],
    }), plan = _21[0], setPlan = _21[1];
    var actionFlags = findParamInLocalStorage("", "afy-action-flags");
    var flagFound = actionFlags === null || actionFlags === void 0 ? void 0 : actionFlags.find(function (flag) { return flag.name === "afy-plan-show-table-primes"; });
    var showTablePrimes = (flagFound === null || flagFound === void 0 ? void 0 : flagFound.value) === "true";
    var _22 = React.useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _22[0], setSeeToast = _22[1];
    var _23 = React.useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToastAlertNext = _23[0], setSeeToastAlertNext = _23[1];
    var _24 = useCompleteStep(), runComplete = _24.runComplete, loadingComplete = _24.loadingComplete, responseComplete = _24.responseComplete, errorComplete = _24.errorComplete;
    var _25 = GetCatalogPlanReference(triggerCatalog, enable, page, limit, clientId || "", planCatalogType), responseGetCatalogPlanReference = _25.responseGetCatalogPlanReference, loadingGetCatalogPlanReference = _25.loadingGetCatalogPlanReference, errorGetCatalogPlanReference = _25.errorGetCatalogPlanReference;
    var _26 = useSelectors(), responsePlans = _26.responsePlans, errorPlans = _26.errorPlans, loadingPlans = _26.loadingPlans, responsePaymentMode = _26.responsePaymentMode, errorPaymentMode = _26.errorPaymentMode, loadingPaymentMode = _26.loadingPaymentMode, responseAllQuote = _26.responseAllQuote, errorAllQuote = _26.errorAllQuote, loadingAllQuote = _26.loadingAllQuote, responseTravelPremiums = _26.responseTravelPremiums, errorTravelPremiums = _26.errorTravelPremiums, loadingTravelPremiums = _26.loadingTravelPremiums;
    var _27 = useUI(navigateBack, STEP, navigate, setPlanPage, setPlanLimit, setShowDetails, setShowDetail, setShowCompareDetail, setShowModalQuotes, plan, setPlan, setNamePlan), onClickBack = _27.onClickBack, onChangePage = _27.onChangePage, onChangeRowsPerPage = _27.onChangeRowsPerPage, closeDetail = _27.closeDetail, onClickNewQuoteModal = _27.onClickNewQuoteModal, clickView = _27.clickView, searchFilter = _27.searchFilter;
    var _28 = usePlan(setRowsQuotes, planSelectedNextStep, setShowModalQuotes, navigate, projectId, enable, page, limit, planPage, planLimit, namePlan, paymentModelSelected, coverTypeSelected, clientId, plan, setPlan, setUpdating, changedPlanId, setPaymentModeData, paymentMode, setPaymentMode, campaignInfo, setCampaignData, setPaymentModelSelected, setChangedPlanId, setSelectedPlanId, setCoverTypeSelected, selectedPlanId, setShowDetails, setShowDetail, setShowCompareDetail, setPlanSelected, setPlanSelectedNextStep, setFiltersQuotes, insuranceType, insurance, runComplete, setSeeToastAlertNext, setNamePlan, dropDown0Options, setSelectedDropDown0, showTablePrimes), buildDataRowsQuotes = _28.buildDataRowsQuotes, setCoverTypeStorybook = _28.setCoverTypeStorybook, callDispatchPaymentMode = _28.callDispatchPaymentMode, callDispatchPlan = _28.callDispatchPlan, updateCoverPrice = _28.updateCoverPrice, clickChangePaymentMode = _28.clickChangePaymentMode, clickDetails = _28.clickDetails, clickCompareDetails = _28.clickCompareDetails, savePlan = _28.savePlan, onClickSelectRowQuote = _28.onClickSelectRowQuote, clickCard = _28.clickCard, clickAcquire = _28.clickAcquire, onClickNext = _28.onClickNext, handleCancelSearch = _28.handleCancelSearch;
    // ============================================================================
    // SECCIÓN 1: INICIALIZACIÓN - Se ejecutan al montar el componente
    // ============================================================================
    // 1.1 Limpiar datos de planes al montar
    useEffect(function () {
        dispatch(plansClearData());
    }, [dispatch]);
    // 1.2 Llamar a PaymentMode al inicio
    useEffect(function () {
        callDispatchPaymentMode();
    }, []);
    // ============================================================================
    // SECCIÓN 2: RESPUESTAS DE APIs - Procesar datos cuando llegan
    // ============================================================================
    // 2.1 Procesar respuesta de Summary para filtros
    useEffect(function () {
        var _a;
        var newMap = __spreadArray([], (((_a = summary === null || summary === void 0 ? void 0 : summary.data) === null || _a === void 0 ? void 0 : _a.map(function (e) { return ({
            name: e.label,
            label: e.value,
            type: "label",
        }); })) || []), true);
        if (summaryDisclaimer !== "") {
            var name = "NOTA";
            var value = summaryDisclaimer;
            var disclaimer = [
                {
                    name: name,
                    label: value,
                    type: "label",
                },
            ];
            newMap.push.apply(newMap, disclaimer);
        }
        setFilters(newMap);
    }, [summary, summaryDisclaimer]);
    // 2.2 Procesar catálogo de referencias de persona
    useEffect(function () {
        if (responseGetCatalogPlanReference &&
            responseGetCatalogPlanReference.length > 0
            && (showPersonType || showFeeType)) {
            setShowDropdown0(true);
            var options = responseGetCatalogPlanReference.map(function (item) { return ({
                id: item.id,
                name: item.description,
                value: item.id,
            }); });
            setDropDown0Options(options);
            //console.log(options);
            // Set first record as default selected      
            setSelectedDropDown0(options[0].id);
            setTriggerCatalog(false);
        }
    }, [responseGetCatalogPlanReference, showPersonType, showFeeType]);
    // 2.3 Procesar Payment Mode
    useEffect(function () {
        var _a;
        if (responsePaymentMode && responsePaymentMode.data) {
            var data = responsePaymentMode;
            var result = (_a = data.data) === null || _a === void 0 ? void 0 : _a.map(function (x) {
                var _a;
                return {
                    id: x.catalogPaymentMode.id,
                    label: x.catalogPaymentMode.description,
                    name: x.catalogPaymentMode.description,
                    default: ((_a = x.catalogPaymentMode.description) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase()) === "mensual",
                };
            });
            // Ordenar: Mensual, Trimestral, Semestral, Anual
            if (result && result.length > 0) {
                var order_1 = ["mensual", "trimestral", "semestral", "anual"];
                result.sort(function (a, b) {
                    var aIndex = order_1.indexOf(a.name.toLowerCase());
                    var bIndex = order_1.indexOf(b.name.toLowerCase());
                    return ((aIndex === -1 ? 999 : aIndex) - (bIndex === -1 ? 999 : bIndex));
                });
                var mensual = result.find(function (x) { return x.default === true; });
                if (mensual) {
                    setPaymentModelSelected(mensual);
                }
                else {
                    setPaymentModelSelected(result[0]);
                }
                var ms = setPaymentModeData(null, result);
                setPaymentMode(ms);
            }
        }
    }, [responsePaymentMode]);
    // 2.4 Procesar respuesta de Planes
    useEffect(function () {
        if (responsePlans && responsePlans.data) {
            //Vamos
            var showTravelPrices = false;
            var planCurrency_1 = "";
            var dataST_1 = [];
            flags === null || flags === void 0 ? void 0 : flags.forEach(function (actionFlag) {
                var _a;
                if (actionFlag.name === "afy-plan-range-age") {
                    setEnabledAgeRange(actionFlag.value === "true");
                }
                if (actionFlag.name === "afy-show-plan-travel-range-info") {
                    showTravelPrices = true;
                    setEnableShowExtra(true); // Enable showExtraInfo when travel prices are shown
                }
                if (actionFlag.name === "afy-plan-show-person-type") {
                    setShowPersonType(true);
                    setPlanCatalogType("PLAN_REFERENCE_TYPE");
                    setLabel0("Tipo de Empleado");
                }
                if (actionFlag.name === "afy-plan-show-fee-type") {
                    setShowFeeType(true);
                    setPlanCatalogType("PLAN_FEE_TYPE");
                    setLabel0("Tipo Tarifa");
                }
                if (actionFlag.name === "afy-plan-currency") {
                    planCurrency_1 = (_a = actionFlag.value) !== null && _a !== void 0 ? _a : "RD$";
                }
                if (actionFlag.name === "afy-summary-disclaimer") {
                    setSummaryDisclaimer(actionFlag.value || "");
                }
                if (actionFlag.name === "afy-label-summary-premium") {
                    setPriceTableHeaderPrice(actionFlag.value || "");
                }
            });
            // Call Travel Premiums API if flag is enabled
            if (showTravelPrices && projectId) {
                // Get date values from localStorage
                var fechaSalidaStr = findParamInLocalStorage("fechaSalida");
                var fechaRegresoStr = findParamInLocalStorage("fechaRegreso");
                // Calculate days between dates
                var days = 0;
                if (fechaSalidaStr && fechaRegresoStr) {
                    // Helper function to parse date from either format
                    var parseDate = function (dateStr) {
                        // Check if date is in ISO/GMT format
                        if (dateStr.includes("GMT") ||
                            dateStr.includes("T") ||
                            (dateStr.includes("-") && !dateStr.includes("/"))) {
                            return new Date(dateStr);
                        }
                        else if (dateStr.includes("/")) {
                            // DD/MM/YYYY format
                            var _a = dateStr.split("/"), dia = _a[0], mes = _a[1], anio = _a[2];
                            return new Date(parseInt(anio), parseInt(mes) - 1, parseInt(dia));
                        }
                        else {
                            // Fallback: try to parse as-is
                            return new Date(dateStr);
                        }
                    };
                    var fechaSalida = parseDate(fechaSalidaStr);
                    var fechaRegreso = parseDate(fechaRegresoStr);
                    // Validate that dates are valid
                    if (!isNaN(fechaSalida.getTime()) && !isNaN(fechaRegreso.getTime())) {
                        // Calculate difference in days
                        var diffTime = Math.abs(fechaRegreso.getTime() - fechaSalida.getTime());
                        days = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                    }
                    else {
                        console.error("Invalid dates:", {
                            fechaSalidaStr: fechaSalidaStr,
                            fechaRegresoStr: fechaRegresoStr,
                        });
                    }
                }
                // Get age range values from localStorage
                var edad020 = parseInt(findParamInLocalStorage("edad020")) || 0;
                var edad2174 = parseInt(findParamInLocalStorage("edad2174")) || 0;
                var edad7585 = parseInt(findParamInLocalStorage("edad7585")) || 0;
                var travelPremiumsBody = {
                    data: {
                        fkProjectId: projectId,
                        days: days,
                        range0To20: edad020,
                        range21To74: edad2174,
                        range75To85: edad7585,
                    },
                };
                dispatch(travelPremiums(travelPremiumsBody));
            }
            responsePlans === null || responsePlans === void 0 ? void 0 : responsePlans.data.map(function (item) {
                var _a, _b, _c, _d;
                if ((((_a = item === null || item === void 0 ? void 0 : item.price) === null || _a === void 0 ? void 0 : _a.amount) !== "0.00" && ((_b = item === null || item === void 0 ? void 0 : item.price) === null || _b === void 0 ? void 0 : _b.amount) !== "0") ||
                    showTravelPrices) {
                    // Tabla de precios
                    var priceTableData = [];
                    if (showTablePrimes) {
                        priceTableData = buildPriceTableFromDataPrimes(item.id, paymentModelSelected.id);
                    }
                    dataST_1.push({
                        id: item.id,
                        name: item.name ? item.name.replace(/"/g, "") : "",
                        logo: item.sponsorLogoUrl && item.sponsorLogoUrl,
                        backgroundColor: "#ffffff",
                        currency: showTravelPrices
                            ? "USD"
                            : planCurrency_1 !== ""
                                ? planCurrency_1
                                : ((_c = item === null || item === void 0 ? void 0 : item.price) === null || _c === void 0 ? void 0 : _c.currencySymbol) || "RD$",
                        itemsValue: [],
                        option: setCoverTypeStorybook(item.coverTypes ? item.coverTypes : []),
                        period: paymentModelSelected.name,
                        benefits: item.benefits,
                        scenaries: item.scenaries,
                        priceTableData: priceTableData,
                        code: item.code,
                        price: ((_d = item === null || item === void 0 ? void 0 : item.price) === null || _d === void 0 ? void 0 : _d.amount) ? item.price.amount : "0",
                        textColor: "#3A56A1",
                        catalogId: item.catalogId,
                    });
                }
            });
            setAllPlans(dataST_1);
            setPlan(__assign(__assign({}, plan), { data: dataST_1 }));
            if (responsePlans === null || responsePlans === void 0 ? void 0 : responsePlans.pagingInfo) {
                setCountPagination(responsePlans === null || responsePlans === void 0 ? void 0 : responsePlans.pagingInfo.totalItems);
            }
            dispatch(plansClearData());
        }
    }, [responsePlans]);
    // 2.5 Procesar Travel Premiums (actualiza precios de planes)
    useEffect(function () {
        if (responseTravelPremiums && responseTravelPremiums.data) {
            // Update plan prices with travel premiums
            if (plan.data && plan.data.length > 0) {
                var updatedPlans = plan.data.map(function (planItem) {
                    var _a;
                    // Find matching premium data by planCode
                    var premiumData = responseTravelPremiums.data.find(function (premium) { return premium.planCode === planItem.code; });
                    if (premiumData && premiumData.premiums) {
                        // Calculate total premium by summing all age ranges
                        var totalPremium = premiumData.premiums.reduce(function (sum, range) { return sum + (range.premium || 0); }, 0);
                        // Update scenaries with premium prices
                        var updatedScenaries = (_a = planItem.scenaries) === null || _a === void 0 ? void 0 : _a.map(function (scenario) {
                            // Find matching premium by range
                            var premiumForRange = null;
                            var order = 0;
                            if (scenario.name.includes("0 hasta: 20") ||
                                scenario.name.includes("0 - 20")) {
                                premiumForRange = premiumData.premiums.find(function (p) { return p.range === "range0To20"; });
                                order = 0;
                            }
                            else if (scenario.name.includes("21 hasta: 74") ||
                                scenario.name.includes("21 - 74")) {
                                premiumForRange = premiumData.premiums.find(function (p) { return p.range === "range21To74"; });
                                order = 1;
                            }
                            else if (scenario.name.includes("75 hasta: 85") ||
                                scenario.name.includes("75 - 85")) {
                                premiumForRange = premiumData.premiums.find(function (p) { return p.range === "range75To85"; });
                                order = 2;
                            }
                            return __assign(__assign({}, scenario), { price: premiumForRange
                                    ? premiumForRange.premium.toFixed(2)
                                    : scenario.price, order: order });
                        }).sort(function (a, b) { return a.order - b.order; });
                        return __assign(__assign({}, planItem), { price: totalPremium.toFixed(2), scenaries: updatedScenaries || planItem.scenaries });
                    }
                    return planItem;
                });
                setPlan(__assign(__assign({}, plan), { data: updatedPlans }));
            }
            // Map and store premium values into the plan step details in localStorage
            var planCodeToPrefix_1 = {
                A00: "A",
                B00: "B",
                C00: "C",
                D00: "D",
            };
            var rangeToSuffix_1 = {
                range0To20: "020",
                range21To74: "2174",
                range75To85: "7585",
            };
            var premiumsData_1 = {};
            responseTravelPremiums.data.forEach(function (planPremium) {
                var prefix = planCodeToPrefix_1[planPremium.planCode];
                if (prefix && planPremium.premiums) {
                    planPremium.premiums.forEach(function (p) {
                        var _a;
                        var suffix = rangeToSuffix_1[p.range];
                        if (suffix) {
                            premiumsData_1["premium".concat(prefix).concat(suffix)] = (_a = p.premium) !== null && _a !== void 0 ? _a : 0;
                        }
                    });
                }
            });
            updateStepByPath("/plan", premiumsData_1);
            dispatch(travelPremiumsClearData());
        }
    }, [responseTravelPremiums]);
    // 2.5b Handle Travel Premiums errors
    useEffect(function () {
        if (errorTravelPremiums) {
            showErrorToast(errorTravelPremiums, setSeeToast, t);
            dispatch(travelPremiumsClearData());
        }
    }, [errorTravelPremiums]);
    // 2.6 Procesar respuesta de AllQuote - Construir filtros
    useEffect(function () {
        if (responseAllQuote) {
            setFiltersQuotes([
                {
                    label: insuranceType,
                    name: "Tipo de Seguro",
                    type: "label",
                },
                {
                    label: insurance,
                    name: "Seguro",
                    type: "label",
                },
                {
                    label: planSelectedNextStep.name,
                    name: "Plan",
                    type: "label",
                },
                {
                    label: campaignInfo ? campaignInfo === null || campaignInfo === void 0 ? void 0 : campaignInfo["0"].name : "",
                    name: "Campaña",
                    type: "label",
                },
            ]);
        }
    }, [responseAllQuote]);
    // 2.7 Procesar respuesta de AllQuote - Construir filas
    useEffect(function () {
        var quoteList = getQuoteList(responseAllQuote);
        if (quoteList.length > 0) {
            buildDataRowsQuotes(quoteList);
        }
    }, [responseAllQuote]);
    // ============================================================================
    // SECCIÓN 3: CAMBIOS DE ESTADO DERIVADOS - Reaccionar a cambios de estado
    // ============================================================================
    // 3.1 Filtrar planes por tipo de catalogo
    useEffect(function () {
        if (showDropdown0 && selectedDropDown0 && allPlans.length > 0) {
            var filteredPlans = allPlans.filter(function (planItem) { return planItem.catalogId === selectedDropDown0; });
            setPlan(__assign(__assign({}, plan), { data: filteredPlans }));
        }
        else if (showDropdown0 && !selectedDropDown0 && allPlans.length > 0) {
            setPlan(__assign(__assign({}, plan), { data: allPlans }));
        }
    }, [selectedDropDown0, allPlans, showDropdown0]);
    // 3.2 Actualizar precio cuando cambia coverType
    useEffect(function () {
        if (coverTypeSelected && coverTypeSelected.id) {
            updateCoverPrice(planSelected, coverTypeSelected);
        }
    }, [coverTypeSelected]);
    // ============================================================================
    // SECCIÓN 4: ACCIONES DEL USUARIO - Responder a cambios del usuario
    // ============================================================================
    // 4.1 Llamar a planes cuando cambia el modo de pago (después de carga inicial)
    useEffect(function () {
        if (paymentModelSelected.id && !isInitialLoad) {
            callDispatchPlan();
        }
    }, [paymentModelSelected]);
    // 4.2 Buscar planes por nombre
    useEffect(function () {
        if (namePlan) {
            callDispatchPlan();
        }
    }, [namePlan]);
    // 4.3 Manejar paginación y carga inicial de planes
    useEffect(function () {
        var isMounted = true;
        var callPlan = function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (isMounted && paymentModelSelected.id) {
                    callDispatchPlan();
                    setIsInitialLoad(false);
                }
                return [2 /*return*/];
            });
        }); };
        callPlan();
        return function () {
            isMounted = false;
        };
    }, [planPage, planLimit, paymentModelSelected.id]);
    // ============================================================================
    // MANEJO CENTRALIZADO DE ERRORES
    // ============================================================================
    useErrorHandling({
        errorPlans: errorPlans,
        errorPaymentMode: errorPaymentMode,
        errorAllQuote: errorAllQuote,
        errorGetCatalogPlanReference: errorGetCatalogPlanReference,
        errorTravelPremiums: errorTravelPremiums,
        errorComplete: errorComplete,
        setSeeToast: setSeeToast,
    });
    return (_jsxs(_Fragment, { children: [_jsx(PlansHeader, { loading: loadingPlans || updating || loadingTravelPremiums || loadingComplete, seeToast: seeToast, setSeeToast: setSeeToast, seeToastAlertNext: seeToastAlertNext, setSeeToastAlertNext: setSeeToastAlertNext, breadCrumbs: breadCrumbs, steps: stepsData, title: plan.titlePage }), _jsx(PagesHeader, { titlePage: "Detalle del plan", hideStep: false, steps: steps, completed: isLastPage }), paymentMode &&
                paymentMode.length > 0 &&
                !loadingGetCatalogPlanReference && (_jsx(PlanView, { error: error, showDropdown0: showDropdown0, helperText: helperText, dropDown0Options: dropDown0Options, Label0: label0, planSelected: planSelected, paymentMode: paymentMode, campaignInfo: campaignInfo, listIdentificationType: [], showDetail: showDetail, showCompareDetail: showCompareDetail, closeDetail: closeDetail, plan: plan, breadCrumbs: breadCrumbs, clickDetails: clickDetails, clickCompareDetail: clickCompareDetails, onClickCompareItem: function () { }, clickChangePaymentMode: clickChangePaymentMode, searchFilter: searchFilter, clickView: clickView, clickCard: clickCard, steps: stepsData, onClickAcquire: clickAcquire, clickChip: function () { }, onClickNext: function () { }, onClickBack: onClickBack, extraInfoNames: extraInfoNames, insurance: insurance, insuranceType: insuranceType, showExtraInfo: enableAgeRange || enableShowExtra, showQuotes: showModalQuotes, onCloseModalQuote: onCloseModalQuotes, filtersQuote: filtersQuotes, rowsQuote: rowsQuotes, onClickSelectRowQuote: onClickSelectRowQuote, onClickNewQuote: onClickNewQuoteModal, filterTitleInsuranceInformation: "Información", showInformation: false, onCancelSearch: handleCancelSearch, insurancePage: planPage, insuranceLimit: planLimit, countPagination: countPagination, onChangePage: onChangePage, onChangeRowsPerPage: onChangeRowsPerPage, filters: filters, showTablePrimes: showTablePrimes, priceTableHeaderPrice: priceTableHeaderPrice }))] }));
};
export default Plan;
